export const config = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DB_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  crossOriginIsolated: process.env.FIREBASE_DB_URL.includes("localhost")
};

export const isLocalDev =
  process.env.NODE_ENV &&
  process.env.NODE_ENV == "development" &&
  process.env.FIREBASE_DB_URL.includes("localhost");
